import { Image } from "../../../fe-ui/atoms/Image";
import { ContentRendererContainer } from "./ContentRendererContainer";

interface Props {
  containerProps?: any;
  media?: any;
}

export function ContentRendererImage(block: Props) {
  const {
    containerProps,
    media,
  } = block || {};

  return (
    <ContentRendererContainer containerProps={containerProps}>
      <Image
        alt=""
        draggable={false}
        src={media?.data?.attributes?.url}
        sx={{ borderRadius: 3, lineHeight: 0 }}
      />
    </ContentRendererContainer>
  )
}
